<!-- signature-document.component.html -->

<h2 mat-dialog-title fxLayout="row" fxLayoutAlign="start center">
  <ng-container *ngIf="state === 'LIST'">Selecionar certificado</ng-container>
  <ng-container *ngIf="state === 'FLOW'">{{ selectedClearance?.productName }}</ng-container>
</h2>

<mat-dialog-content fxLayout="column" fxLayoutGap="12px">

  <!-- LIST -->
  <ng-container *ngIf="state === 'LIST'">

    <div *ngIf="signingA1" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
      <mat-progress-spinner diameter="22" mode="indeterminate"></mat-progress-spinner>
      <span>Assinando com certificado A1...</span>
    </div>

    <div *ngIf="a1ErrorMsg" class="a1-sign-error" role="alert">{{ a1ErrorMsg }}</div>

    <div *ngIf="loading" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
      <mat-progress-spinner diameter="22" mode="indeterminate"></mat-progress-spinner>
      <span>Carregando opções…</span>
    </div>

    <div *ngIf="!loading && errorMsg" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="12px">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
        <mat-icon color="warn">error</mat-icon>
        <span>{{ errorMsg }}</span>
      </div>

      <button mat-stroked-button (click)="loadClearances()">Tentar novamente</button>
    </div>

    <mat-nav-list *ngIf="!loading && !errorMsg && clearances?.length">

      <a mat-list-item
         *ngFor="let c of clearances"
         (click)="!signingA1 && select(c)"
         class="clearance-item"
         fxLayout="row"
         fxLayoutAlign="start center"
         style="border-radius:14px; margin-bottom:10px; cursor:pointer; padding:10px 8px;">

        <!-- START: imagem -->
        <div fxLayout="row" fxLayoutAlign="center center"
             style="width:96px; min-width:96px;">
          <div fxLayout="row" fxLayoutAlign="center center"
               style="width:72px; height:72px; border-radius:16px;">
            <img [src]="getClearanceImage(c.productName)"
                 [alt]="c.productName"
                 width="56" height="56"
                 style="object-fit: contain;" />
          </div>
        </div>

        <!-- MIDDLE: nome -->
        <div fxFlex fxLayout="column" fxLayoutAlign="center start" style="padding:0 16px;">
          <span style="font-weight:600; font-size:16px;">
            {{ c.productName }}
          </span>
          <span style="opacity:.65; font-size:13px; margin-top:2px;">
            {{ c.providerName }}
          </span>
        </div>

        <!-- END: chevron -->
        <div fxLayout="row" fxLayoutAlign="center center" style="width:40px; min-width:40px;">
          <mat-icon style="opacity:.6;">chevron_right</mat-icon>
        </div>

      </a>

    </mat-nav-list>

    <div *ngIf="!loading && !errorMsg && (!clearances || clearances.length === 0)"
         fxLayout="row" fxLayoutAlign="center center" style="opacity:.7;">
      Nenhuma opção disponível.
    </div>

  </ng-container>

  <!-- FLOW -->
  <ng-container *ngIf="state === 'FLOW'">

    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
      <button mat-icon-button (click)="back()" [disabled]="authPolling">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <span style="opacity:.8;">Voltar</span>
    </div>

    <div fxLayout="column" fxLayoutGap="16px" style="padding-top:8px;">

      <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
        <mat-icon>info</mat-icon>
        <div>
          <div style="font-weight:600;">Autorização aberta em nova aba</div>
          <div style="opacity:.75; font-size:13px;">
            O provedor não permite execução dentro do sistema.
          </div>
        </div>
      </div>

      <button mat-raised-button color="primary" (click)="openAgain()" [disabled]="authDone">
        Abrir novamente
      </button>

      <!-- aguardando -->
      <div *ngIf="!authDone" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" style="opacity:.9;">
        <mat-progress-spinner diameter="22" mode="indeterminate"></mat-progress-spinner>
        <span>Aguardando autorização…</span>
      </div>

      <!-- concluído -->
      <div *ngIf="authDone" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" style="opacity:.95;">
        <mat-icon color="primary">check_circle</mat-icon>
        <div>
          <div style="font-weight:600;">Autenticado ✅</div>
          <div style="opacity:.75; font-size:13px;">Você pode continuar para assinatura.</div>
        </div>
      </div>

      <button *ngIf="authDone" mat-raised-button color="accent" (click)="continueAfterAuth()">
        Continuar
      </button>

    </div>

  </ng-container>

</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <button mat-button (click)="close()">Fechar</button>
</mat-dialog-actions>
